
import socketIOClient from "socket.io-client";
import { BASE_URL } from "src/config/constants";
import { store } from "../store";
import { addMessages } from "../store/reducers/message";


const ENDPOINT = BASE_URL;
let created = false;
let socket = null;

class SocketIO {

  static init() {
    socket = socketIOClient(ENDPOINT);
    if (created) return;
    created = true;
    socket.on("connect", (data) => {
      console.log('connected');
      // socket.emit('register', { 'uid': store.getState().userInfo.userInfo.uid });
      socket.emit("admin");
    });

    socket.on("private", (data) => {
      // console.log('privte', typeof data.message.info);
      console.log('privte', data);
      store.dispatch(addMessages({
        ...data.message,
        info: JSON.parse(data.message.info)
      }));
    });

    socket.on("disconnect", (data) => {
      console.log('disconnected');
    });

  }

  static sendPrivateMsg(topic, msg) {
    socket.emit(topic, msg);
  }

  static destroy() {
    if (!created) return;
    created = false;
    socket.disconnect();
    socket.dispose();
  }

}

export default SocketIO;